module.exports = __webpack_public_path__ + "static/copy.svg";